"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _KeyboardArrowDown = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowDown"));

var _material = require("@mui/material");

var _ErrorHelperText = _interopRequireDefault(require("../ErrorHelperText"));

var _styledComponents = require("./styledComponents");

var _excluded = ["label", "error", "placeholder", "items", "helperText", "popover", "value", "onChange"];

var Select = function Select(_ref) {
  var label = _ref.label,
      error = _ref.error,
      placeholder = _ref.placeholder,
      items = _ref.items,
      helperText = _ref.helperText,
      popover = _ref.popover,
      value = _ref.value,
      onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var hasError = error.constructor === Object && Object.keys(error).length !== 0;
  var hasHelperText = helperText.length > 0;

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handlePopoverOpen = function handlePopoverOpen(event) {
    setAnchorEl(event.currentTarget);
  };

  var handlePopoverClose = function handlePopoverClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  return /*#__PURE__*/_react.default.createElement(_material.FormControl, Object.assign({
    size: "medium",
    fullWidth: true,
    "aria-label": "formcontrol"
  }, props), label && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInputLabel, {
    shrink: true,
    htmlFor: label,
    error: hasError
  }, label, popover && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledIconButton, {
    onMouseEnter: handlePopoverOpen,
    onMouseLeave: handlePopoverClose
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInfoIcon, {
    "aria-label": "popover-icon"
  })), /*#__PURE__*/_react.default.createElement(_styledComponents.StyledPopOver, {
    id: "mouse-over-popover",
    "aria-label": "popover",
    open: open,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    onClose: handlePopoverClose,
    disableRestoreFocus: true
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInfoMessage, null, popover)))), /*#__PURE__*/_react.default.createElement(_styledComponents.StyledSelect, Object.assign({
    IconComponent: _KeyboardArrowDown.default,
    displayEmpty: !!placeholder,
    value: value || '',
    onChange: onChange,
    error: hasError,
    "data-testid": "select-test" // autoWidth
    ,
    MenuProps: {
      sx: _styledComponents.MenuPropsSx
    }
  }, props), placeholder && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledMenuItemPlaceholder, {
    value: "",
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledPlaceholder, null, placeholder)), items.length > 0 && items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_styledComponents.StyledMenuItem, {
      key: item.value,
      value: item.value
    }, item.label);
  })), hasError && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledWrapperError, null, /*#__PURE__*/_react.default.createElement(_ErrorHelperText.default, null, error.message)), hasHelperText && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledFormHelperText, null, helperText));
};

Select.defaultProps = {
  label: '',
  placeholder: '',
  id: '',
  helperText: '',
  popover: '',
  error: {},
  value: ''
};
var _default = Select;
exports.default = _default;